import{Box2,Color}from"three";/**
 * MapBlock class (formerly ABlock)
 * contains infos about a block, that is one top and one bottom mesh
 */export class MapBlock{constructor(){this.id=MapBlock.ID++;// Renamed from ABlock
this.typeBottom=0;this.typeTop=0;this.box=new Box2();this.height=1;this.rotation=0;this.topColorIndex=0;this.bottomGeomId=void 0;this.topGeomId=void 0;this.topColor=MapBlock.LIGHT_COLORS[this.topColorIndex];// Renamed from ABlock
this.baseColor=MapBlock.LIGHT_BASE_COLOR;}// Renamed from ABlock
setTopColorIndex(index){this.topColorIndex=index;this.topColor=MapBlock.LIGHT_COLORS[this.topColorIndex];// Renamed from ABlock
}}// Renamed from ABlock
MapBlock.LIGHT_COLORS=[new Color(0xff6b6b),// Bright red
new Color(0x4ecdc4),// Bright teal
new Color(0x45b7d1),// Bright blue
new Color(0x96ceb4),// Bright green
new Color(0xfeca57),// Bright yellow
new Color(0xff9ff3),// Bright pink
new Color(0x54a0ff),// Bright sky blue
new Color(0x5f27cd)// Bright purple
];MapBlock.DARK_COLORS=[new Color(0xc44569),// Dark red
new Color(0x00d2d3),// Dark teal
new Color(0x0abde3),// Dark blue
new Color(0x00cec9),// Dark green
new Color(0xffd32a),// Dark yellow
new Color(0xff3838),// Dark pink
new Color(0x3742fa),// Dark sky blue
new Color(0x2f3542)// Dark purple
];MapBlock.ID=0;MapBlock.LIGHT_BASE_COLOR=new Color(0x666666);MapBlock.DARK_BASE_COLOR=new Color(0x111111);